import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const deleteModalTextLiteratureSlice = createSlice({
  name: "deleteModalTextLiterature",
  initialState,
  reducers: {
    openModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModalDelete, closeModalDelete } = deleteModalTextLiteratureSlice.actions;
export default deleteModalTextLiteratureSlice.reducer;
